import React from "react";
import {
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Radio,
  RadioGroup,
  Checkbox,
  TextField,
} from "@mui/material";
import InputComponent from "../InputComponent";
import TextFieldComponentLarge from "../TextFieldComponentLarge";

function AdmissionMentalHealth({
  mentalHealthDiagnosis,
  handleMentalHealthDiagnosisChange,
  anxiety,
  handleAnxietyChange,
  depression,
  handleDepressionChange,
  ptsd,
  handlePtsdChange,
  personalityDisorder,
  handlePersonalityDisorderChange,
  specificDisorder,
  handleSpecificDisorderChange,
  schizophrenia,
  handleSchizophreniaChange,
  schizoaffectiveDisorder,
  handleSchizoaffectiveDisorderChange,
  bipolar,
  handleBipolarChange,
  adhd,
  handleAdhd,
  mentalHealthOtherCheck,
  handleMentalHealthOtherCheck,
  mentalHealthOtherContent,
  handleMentalHealthOtherContent,
  bipolarWithPsychoticFeatures,
  handleBipolarWithPsychoticFeaturesChange,
  hallucinations,
  handleHallucinationsChange,
  hallucinationsExplain,
  handleHallucinationsExplainChange,
  delusionalThinking,
  handleDelusionalThinking,
  delusionalThinkingExplain,
  handleDelusionalThinkingExplain,
  currentMentalHealthIssues,
  handleCurrentMentalHealthIssuesChange,
  suicidalThoughts,
  handleSuicidalThoughtsChange,
  suicidalThoughtsWhen,
  handleSuicidalThoughtsWhenChange,
  suicidalThoughtsIntent,
  handleSuicidalThoughtsIntentChange,
  suicidePlan,
  handleSuicidePlanChange,
  historyOfSuicideAttempts,
  handleHistoryOfSuicideAttemptsChange,
  suicideAttemptsWhen,
  handleSuicideAttemptsWhenChange,
  selfHarmType,
  handleSelfHarmTypeChange,
  lastSelfHarm,
  handleLastSelfHarmChange,
  traumaHistory,
  handleTraumaHistoryChange,
  traumaTreatment,
  handleTraumaTreatmentChange,
  historyPhysicalViolent,
  handleHistoryPhysicalViolence,
  mentalHealthTreatment,
  handleMentalHealthTreatmentChange,
  currentProvider,
  handleCurrentProviderChange,
}) {
  return (
    <div className="container-main-plan margin-bottom-2">
      <div className="tab-container-title-2B">Mental health</div>
      <div className="tab-form-container">
        <div className="yes-no-container-column-2">
          <FormControl
            style={{
              marginLeft: 40,
              border: !mentalHealthDiagnosis ? "1px solid red" : "none",
              padding: "10px",
              borderRadius: "5px",
            }}
            error={!mentalHealthDiagnosis}
          >
            <FormLabel
              id="demo-controlled-radio-buttons-group"
              style={{ color: !mentalHealthDiagnosis ? "red" : "black" }}
            >
              Have you ever been formally diagnosed with a mental health issue
              by a mental health practioner?
            </FormLabel>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={mentalHealthDiagnosis}
              onChange={handleMentalHealthDiagnosisChange}
            >
              <FormControlLabel value="yes" control={<Radio />} label="Yes" />
              <FormControlLabel value="no" control={<Radio />} label="No" />
            </RadioGroup>
            {!mentalHealthDiagnosis && (
              <span style={{ color: "red", fontSize: "12px" }}>
                Please select an option
              </span>
            )}
          </FormControl>
          <div className="yes-no-container-column">
            <div className="sentence-yes-no-5">If yes, which one :</div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                justifyContent: "center",
              }}
            >
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox checked={anxiety} onChange={handleAnxietyChange} />
                  }
                  label="Anxiety"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={depression}
                      onChange={handleDepressionChange}
                    />
                  }
                  label="Depression"
                />
                <FormControlLabel
                  control={<Checkbox checked={ptsd} onChange={handlePtsdChange} />}
                  label="PTSD"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={personalityDisorder}
                      onChange={handlePersonalityDisorderChange}
                    />
                  }
                  label="Any Personality Disorder"
                />

                {personalityDisorder && (
                  <TextField
                    label="Specify"
                    value={specificDisorder}
                    onChange={handleSpecificDisorderChange}
                  />
                )}

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={schizophrenia}
                      onChange={handleSchizophreniaChange}
                    />
                  }
                  label="Schizophrenia"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={schizoaffectiveDisorder}
                      onChange={handleSchizoaffectiveDisorderChange}
                    />
                  }
                  label="Schizoaffective disorder"
                />
                <FormControlLabel
                  control={
                    <Checkbox checked={bipolar} onChange={handleBipolarChange} />
                  }
                  label="Bipolar I or II"
                />

                <FormControlLabel
                  control={<Checkbox checked={adhd} onChange={handleAdhd} />}
                  label="ADHD/ADD"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={mentalHealthOtherCheck}
                      onChange={handleMentalHealthOtherCheck}
                    />
                  }
                  label="Other"
                />

                {mentalHealthOtherCheck ? (
                  <InputComponent
                    title="If other selected, describe"
                    width="150"
                    value={mentalHealthOtherContent}
                    onChange={handleMentalHealthOtherContent}
                  />
                ) : (
                  ""
                )}
              </FormGroup>
            </div>
          </div>
        </div>

        <div className="yes-no-container" style={{ marginLeft: "40px" }}>
          <FormControl>
            <FormLabel
              id="demo-controlled-radio-buttons-group"
              style={{ color: "black" }}
            >
              If bipolar: with psychotic features? :
            </FormLabel>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={bipolarWithPsychoticFeatures}
              onChange={handleBipolarWithPsychoticFeaturesChange}
            >
              <FormControlLabel value="yes" control={<Radio />} label="Yes" />
              <FormControlLabel value="no" control={<Radio />} label="No" />
            </RadioGroup>
          </FormControl>
        </div>

        <div className="yes-no-container-column" style={{ marginLeft: "40px" }}>
          <FormControl
            style={{
              marginBottom: "20px",
              border: !hallucinations ? "1px solid red" : "none",
              padding: "10px",
            }}
          >
            <FormLabel
              id="demo-controlled-radio-buttons-group"
              style={{ color: !hallucinations ? "red" : "black" }}
            >
              Have you ever experienced any hallucinations (hearing things or
              seeing things that were not there)?
            </FormLabel>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={hallucinations}
              onChange={handleHallucinationsChange}
            >
              <FormControlLabel value="yes" control={<Radio />} label="Yes" />
              <FormControlLabel value="no" control={<Radio />} label="No" />
            </RadioGroup>
            {!hallucinations && (
              <div style={{ color: "red", marginTop: "5px" }}>
                Please select an option
              </div>
            )}
          </FormControl>

          <TextFieldComponentLarge
            title="If yes, please explain"
            width="300"
            value={hallucinationsExplain}
            onChange={handleHallucinationsExplainChange}
          />
        </div>

        <div className="yes-no-container-column" style={{ marginLeft: "40px" }}>
          <FormControl
            style={{
              marginBottom: "20px",
              border: !delusionalThinking ? "1px solid red" : "none",
              padding: "10px",
            }}
          >
            <FormLabel
              id="demo-controlled-radio-buttons-group"
              style={{ color: !delusionalThinking ? "red" : "black" }}
            >
              Have you ever experienced delusional thinking (e.g., paranoia,
              persecution, others knowing your thoughts)?
            </FormLabel>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={delusionalThinking}
              onChange={handleDelusionalThinking}
            >
              <FormControlLabel value="yes" control={<Radio />} label="Yes" />
              <FormControlLabel value="no" control={<Radio />} label="No" />
            </RadioGroup>
            {!delusionalThinking && (
              <div style={{ color: "red", marginTop: "5px" }}>
                Please select an option
              </div>
            )}
          </FormControl>

          <TextFieldComponentLarge
            title="If yes, please explain"
            width="300"
            value={delusionalThinkingExplain}
            onChange={handleDelusionalThinkingExplain}
          />
        </div>
      </div>
      <div className="tab-form-container-bis">
        <TextFieldComponentLarge
          title="Are you currently experiencing mental health issues? "
          placeholder="e.g., depression, anxiety, mania"
          value={currentMentalHealthIssues}
          onChange={handleCurrentMentalHealthIssuesChange}
          showValidation={true}
        />
      </div>
      <div className="yes-no-container-column" style={{ marginLeft: "40px" }}>
        <FormControl
          style={{
            marginBottom: "20px",
            border: !suicidalThoughts ? "1px solid red" : "none",
            padding: "10px",
          }}
        >
          <FormLabel
            id="demo-controlled-radio-buttons-group"
            style={{ color: !suicidalThoughts ? "red" : "black" }}
          >
            Have you had any suicidal thoughts in the past weeks or days or
            currently?
          </FormLabel>
          <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={suicidalThoughts}
            onChange={handleSuicidalThoughtsChange}
          >
            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
            <FormControlLabel value="no" control={<Radio />} label="No" />
          </RadioGroup>
          {!suicidalThoughts && (
            <div style={{ color: "red", marginTop: "5px" }}>
              Please select an option
            </div>
          )}
        </FormControl>

        <TextFieldComponentLarge
          title="If so, when?"
          width="300"
          value={suicidalThoughtsWhen}
          onChange={handleSuicidalThoughtsWhenChange}
        />
        <TextFieldComponentLarge
          title="If so, with intent?"
          width="300"
          value={suicidalThoughtsIntent}
          onChange={handleSuicidalThoughtsIntentChange}
        />
      </div>

      <div className="tab-form-container-bis">
        <TextFieldComponentLarge
          title="If current SI, have you made a plan on how you would kill yourself?"
          width="500"
          value={suicidePlan}
          onChange={handleSuicidePlanChange}
        />

        <div className="yes-no-container-column" style={{ marginLeft: "0px" }}>
          <FormControl
            style={{
              marginBottom: "20px",
              border: !historyOfSuicideAttempts ? "1px solid red" : "none",
              padding: "10px",
            }}
          >
            <FormLabel
              id="demo-controlled-radio-buttons-group"
              style={{ color: !historyOfSuicideAttempts ? "red" : "black" }}
            >
              History of Suicide Attempts :
            </FormLabel>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={historyOfSuicideAttempts}
              onChange={handleHistoryOfSuicideAttemptsChange}
            >
              <FormControlLabel value="yes" control={<Radio />} label="Yes" />
              <FormControlLabel value="no" control={<Radio />} label="No" />
            </RadioGroup>
            {!historyOfSuicideAttempts && (
              <div style={{ color: "red", marginTop: "5px" }}>
                Please select an option
              </div>
            )}
          </FormControl>

          <InputComponent
            title="If so, when?"
            width="300"
            value={suicideAttemptsWhen}
            onChange={handleSuicideAttemptsWhenChange}
          />
        </div>

        <TextFieldComponentLarge
          title="Self-Harm (Current or Past) and Type"
          placeholder="e.g., cutting, burning, hair pulling"
          value={selfHarmType}
          onChange={handleSelfHarmTypeChange}
          showValidation={true}
        />
        <TextFieldComponentLarge
          title="If so, when was the last time you engaged in self-harm behavior?"
          value={lastSelfHarm}
          onChange={handleLastSelfHarmChange}
        />
        <TextFieldComponentLarge
          title="Trauma History"
          value={traumaHistory}
          onChange={handleTraumaHistoryChange}
          showValidation={true}
        />
        <TextFieldComponentLarge
          title="Current or Past Trauma Treatment"
          value={traumaTreatment}
          onChange={handleTraumaTreatmentChange}
          showValidation={true}
        />
        <TextFieldComponentLarge
          title="History of Physical Violence Towards Others"
          value={historyPhysicalViolent}
          onChange={handleHistoryPhysicalViolence}
          showValidation={true}
        />
        <TextFieldComponentLarge
          title="Current or Past Mental Health Treatment"
          value={mentalHealthTreatment}
          onChange={handleMentalHealthTreatmentChange}
          showValidation={true}
        />
        <TextFieldComponentLarge
          title="Current Provider (name and type of provider)"
          placeholder="e.g., psychiatrist, therapist"
          value={currentProvider}
          onChange={handleCurrentProviderChange}
          showValidation={true}
        />
      </div>
    </div>
  );
}

export default AdmissionMentalHealth;

